import { Component, OnInit } from '@angular/core';
import {FormGroup, FormBuilder, Validators} from '@angular/forms';
import { AuthService } from '../auth.service';
import {Router, ActivatedRoute, NavigationExtras} from '@angular/router';
import {RegularExpressionConstant} from '../utils/regular-expression.constant';
declare var amplitude;

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.page.html',
  styleUrls: ['./forgot-password.page.scss'],
})
export class ForgotPasswordPage implements OnInit {
  forgotPasswordForm: FormGroup;
  isSubmitted = false;
  navigationExtras: any;
  constructor(private router: Router,
  	 		  public authService: AuthService,
  			  public formBuilder: FormBuilder,) {
	this.forgotPasswordForm = this.formBuilder.group({
        email: ["", [Validators.required, Validators.pattern(RegularExpressionConstant.EMAIL)]],
    });
  }

  ngOnInit() {
    this.authService.forgotPasswordSuccess = false;
    this.authService.forgotPasswordError = '';
  }

  ionViewDidEnter() {
    amplitude.logEvent("mobile::viewed_forgot_password_page");
  }

  submitForm() {
  	this.authService.forgotPassword(this.forgotPasswordForm.value);
  }

  onCancelClick() {
    this.router.navigate(['/login'], this.navigationExtras);
  }

  onCloseSuccessMessage() {
    this.authService.forgotPasswordSuccess = false;
    this.authService.forgotPasswordError = '';
    this.router.navigate(['/login'], this.navigationExtras);
  }

}
